import { handleResponse } from '../../Helpers/handle-response';
import * as apiHelper from '../../Helpers/apiHelper';

export function getProductDataByEAN(ean, workstationId, userId) {
    // const requestOptions = {
    //     method: 'GET', headers: {
    //         'Content-Type': 'application/json'
    //     }
    // };

    let url = apiHelper.ComposeUri(apiHelper.API_ACTION_GETPRODUCTDATABYEAN);
    url += `?ean=${ean}`;
    url += `&workstationId=${workstationId}`;
    url += `&userId=${userId}`;

    return fetch(url)
        .then(handleResponse)
        .catch(() => {
            return null;
        });
}

export function getProductionOrdersByEAN(ean, workstationId, userId, finishedAfterDate) {
    // const requestOptions = {
    //     method: 'GET', headers: {
    //         'Content-Type': 'application/json'
    //     }
    // };

    let url = apiHelper.ComposeUri(apiHelper.API_ACTION_GETPRODUCTIONORDERSBYEAN);
    url += `?ean=${ean}`;
    url += `&workstationId=${workstationId}`;
    url += `&userId=${userId}`;
    url += `&finishedAfterDate=${finishedAfterDate}`;

    return fetch(url)
        .then(handleResponse)
        .catch(() => {
            return null;
        });
}

